import { ReactNode, useEffect } from "react";
import { clsx } from "clsx";
import { X } from "lucide-react";

interface Props {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  commandMode?: boolean;
}

export function MobileDrawer({ open, onClose, children, commandMode = false }: Props) {
  useEffect(() => {
    if (!open) return;
    const onEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onEsc);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onEsc);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  return (
    <div
      className={clsx(
        "fixed inset-0 z-40 md:hidden",
        open ? "pointer-events-auto" : "pointer-events-none"
      )}
      aria-hidden={!open}
    >
      <div
        className={clsx(
          "absolute inset-0 bg-stone-950/40 backdrop-blur-sm transition-opacity duration-200",
          open ? "opacity-100" : "opacity-0"
        )}
        onClick={onClose}
      />
      <div
        className={clsx(
          commandMode
            ? "absolute inset-y-0 left-0 flex w-[85vw] max-w-[320px] transform flex-col bg-[#111113] shadow-elevated transition-transform duration-200 ease-out"
            : "absolute inset-y-0 left-0 flex w-[85vw] max-w-[320px] transform flex-col bg-card shadow-elevated transition-transform duration-200 ease-out dark:bg-card-dark",
          open ? "translate-x-0" : "-translate-x-full"
        )}
        style={{ paddingTop: "env(safe-area-inset-top)" }}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="閉じる"
          className="absolute right-2 top-2 z-10 flex h-11 w-11 items-center justify-center rounded-md text-muted dark:text-muted-dark"
          style={{ marginTop: "env(safe-area-inset-top)" }}
        >
          <X className="h-5 w-5" />
        </button>
        <div className="flex-1 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
